import { render } from "./k-list-skeleton.vue?vue&type=template&id=15c2cc44&scoped=true"
import script from "./k-list-skeleton.vue?vue&type=script&lang=js"
export * from "./k-list-skeleton.vue?vue&type=script&lang=js"

import "./k-list-skeleton.vue?vue&type=style&index=0&id=15c2cc44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c2cc44"]])

export default __exports__